import { render, staticRenderFns } from "./PersonalityTraitCard.vue?vue&type=template&id=7e837d97&"
import script from "./PersonalityTraitCard.vue?vue&type=script&lang=js&"
export * from "./PersonalityTraitCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports